import { getDevicePlatform } from "./tools/getDevicePlatform"

export const TEXT_FALLBACK = "N/A"
export const DEVICE_PLATFORM = getDevicePlatform()
